import { defineStore } from 'pinia'
import { ShoppingCart } from '../interfaces/shoppingCart'

export const useShoppingCartStore = defineStore('shoppingCart', {
  state: () => ({
    shoppingCart: {} as Partial<ShoppingCart>
  }),

  getters: {
    getShoppingCart (): Partial<ShoppingCart> {
      return this.shoppingCart
    }
  },

  actions: {
    setShoppingCart (payload: Partial<ShoppingCart>) {
      this.shoppingCart = payload
    }
  }
})
